/* leadyourday · Rechtsseiten: „Stand“-Pille + Inhaltsverzeichnis bei langen Texten (MG Commerce) */
(() => {
  const box = document.querySelector('.shopify-policy__container');
  const body = box && box.querySelector('.shopify-policy__body');
  if (!body) return;

  /* „Stand: …“ / „Letzte Fassung: …“ im ersten Absatz als Pille */
  const first = body.querySelector('.rte p');
  if (first && /^(Stand|Letzte Fassung)\b/i.test(first.textContent.trim()) && first.textContent.length < 60) first.classList.add('lyd-pol__stand');

  /* Inhaltsverzeichnis ab 5 Zwischenüberschriften und längeren Texten (nicht beim Impressum) */
  const hs = [...body.querySelectorAll('h2')].filter((h) => h.textContent.trim());
  if (hs.length < 5 || body.textContent.length < 3000) return;
  const slug = (t, i) => 'abschnitt-' + (i + 1) + '-' + t.toLowerCase().replace(/[äöüß]/g, (c) => ({ ä: 'ae', ö: 'oe', ü: 'ue', ß: 'ss' }[c])).replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '').slice(0, 40);
  const toc = document.createElement('details');
  toc.className = 'lyd-pol__toc';
  const mqDesk = window.matchMedia('(min-width: 1100px)');
  toc.open = mqDesk.matches;
  mqDesk.addEventListener('change', (e) => { toc.open = e.matches; });
  toc.innerHTML = '<summary>Inhalt</summary><nav aria-label="Inhaltsverzeichnis"><ol></ol></nav>';
  const ol = toc.querySelector('ol');
  const links = hs.map((h, i) => {
    if (!h.id) h.id = slug(h.textContent.trim(), i);
    const li = document.createElement('li');
    const a = document.createElement('a');
    a.href = '#' + h.id;
    a.textContent = h.textContent.trim();
    li.appendChild(a); ol.appendChild(li);
    return a;
  });
  const wrap = document.createElement('div');
  wrap.className = 'lyd-pol__wrap';
  body.parentNode.insertBefore(wrap, body);
  wrap.appendChild(toc); wrap.appendChild(body);

  /* Mobil: nach Klick wieder einklappen */
  toc.addEventListener('click', (e) => { if (e.target.closest('a') && !mqDesk.matches) toc.open = false; });

  /* aktiven Abschnitt markieren */
  if ('IntersectionObserver' in window) {
    const io = new IntersectionObserver((es) => {
      es.forEach((e) => {
        if (!e.isIntersecting) return;
        const i = hs.indexOf(e.target);
        links.forEach((a, x) => a.classList.toggle('is-on', x === i));
      });
    }, { rootMargin: '-15% 0px -70% 0px' });
    hs.forEach((h) => io.observe(h));
  }
})();
